<template>
  <div>
    <h3>Ежедневный бонус</h3>
    <p>Бонус за первое пополнение за день начисляется каждый день в размере {{bonus.percent}}% от суммы пополнения.</p>
    <p>Каждый бонус предоставляется на определенных условиях и с определенными ограничениями, которые необходимо выполнить, чтобы получить возможность вывести бонусные средства со счета. В зависимости от типа предлагаемого бонуса, возможно, от вас потребуется выполнить определенные условия для получения возможности вывести со счета средства, полученные при положительном результате пари с использованием бонуса.</p>
    <h5>Порядок начисления бонуса</h5>
    <ol>
      <li>Пополни свой баланс.</li>
      <li>Бонус автоматически начисляется после пополнения баланса, при условии, что в данный момент у игрока нет других активных бонусов</li>
    </ol>

    <h5>Правила и условия</h5>
    <ol>
      <li>Пользователь имеет право получить только 1 бонус в день.</li>
      <li>Бонус начисляется автоматически после первого пополнения аккаунта, при условии, что у игрока нет других активных бонусов в данный момент.</li>
      <li>До выполнения условий отыгрыша вывод бонусных денежных средств невозможен.</li>
      <li>
        Условия отыгрыша
        <ul>
          <li v-if="redPipe && redPipe.contributionPercent > 0">
            Казино: {{redPipe.contributionPercent}}% с каждой ставки, не превышающей
            <template v-for="cs in redPipe.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} для {{cs.currency}},
            </template>
          </li>
          <li v-if="flg && flg.contributionPercent > 0">
            Live Игры: {{flg.contributionPercent}}% с каждой ставки, не превышающей
            <template v-for="cs in flg.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} для {{cs.currency}},
            </template>
          </li>
          <li v-if="bk && bk.contributionPercent > 0">
            Спорт: {{bk.contributionPercent}}% с каждой ставки, не превышающей
            <template v-for="cs in bk.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} для {{cs.currency}},
            </template>
            с коэффициентом >= {{bk.minFactor}}
          </li>
          <li v-if="hdRaces && hdRaces.contributionPercent > 0">
            Виртуальный Спорт: {{hdRaces.contributionPercent}}% с каждой ставки, не превышающей
            <template v-for="cs in hdRaces.currencySettings">
              {{cs.maxBet | currency(cs.currency)}} для {{cs.currency}},
            </template>
            с коэффициентом >= {{hdRaces.minFactor}}
          </li>
        </ul>
      </li>
      <li>Предложение не может быть использовано в комбинации с другими акциями или специальными предложениями.</li>
      <li>Только один бонус доступен для одного пользователя, на семью, один адрес, один общий компьютер, общий IP-адрес, на любые одинаковые данные аккаунта, как адрес e-mail, банковский счёт, информация о кредитной карте, аккаунт платёжной системы. Любое нарушение правил бонусной программы приведёт к закрытию аккаунта.</li>
      <li>Отыгранный бонус переводится на основной счет в размере остатка бонусных средств, но не более {{bonus.convertToRealMaxPercent}}% от первоначально начисленного бонуса.</li>
      <li>При снятии денежных средств бонус аннулируется.</li>
      <li>Правила акции могут быть изменены</li>
    </ol>
  </div>
</template>
<script>
  import Vue from "vue";

  export default {
    name: 'bonus-rules-deposit-ru',
    props: {
      bonus: {
        type: Object,
        required: true
      }
    },
    data() {
      return {
          redPipe: null,
          flg: null,
          bk: null,
          hdRaces: null
      }
    },
    computed: {
      currency() {
        let player = Vue.state.player.get();
        return player && player.balance && player.balance.currency;
      }
    },
    mounted() {
      this.init();
    },
    methods: {
      init() {
        this.redPipe = this.bonus.providers.filter(p => p.provider == 'redpipe')[0];
        this.flg = this.bonus.providers.filter(p => p.provider == 'flg')[0];
        this.bk = this.bonus.providers.filter(p => p.provider == 'bk')[0];
        this.hdRaces = this.bonus.providers.filter(p => p.provider == 'hdraces')[0];
      }
    }
  }
</script>
<style>
</style>



// WEBPACK FOOTER //
// front/src/skins/bulmasite/components/pages/sitepages/bonus-rules/bonus-rules-deposit/ru.vue